import angular from 'angular';
import tableGridTextExtendedCellComponent from './tableGridTextExtendedCell.component';

let tableGridTextExtendedCellModule = angular.module('tableGridTextExtendedCell', []).directive('tableGridTextExtendedCell', tableGridTextExtendedCellComponent);

export default tableGridTextExtendedCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridTextExtendedCell/tableGridTextExtendedCell.js